import { Can } from 'providers/casl'

export const onLayoutAccess = (can: Can) => {
  can('access', 'Layout')
}

export const onGamAccountSidebarItemAccess = (can: Can) => {
  can('access', 'GamAccountSidebarItem')
}

export const onHelpMenuItemAccess = (can: Can) => {
  can('access', 'HelpMenuItem')
}
